import gsap from 'gsap';
import { throttle } from '../common/help_functions';

export function cursorAnimation() {
  const cursor = document.querySelector(".cursor");

  // If cursor undefined
  if (!cursor) {
    return false
  }

  // If device has hover | Work once when page load
  if (!window.matchMedia("(pointer: fine) and (hover: hover)").matches) {
    return false
  }


  const hoverSection = document.querySelectorAll('[data-cursor]');
  let mouseX = 0, mouseY = 0;
  let cursorX = 0, cursorY = 0;
  let speed = 0.1;


  function moveCursor() {
    let distX = mouseX - cursorX;
    let distY = mouseY - cursorY;


    cursorX = cursorX + (distX * speed);
    cursorY = cursorY + (distY * speed);

    gsap.to(cursor, {
      x: cursorX,
      y: cursorY,
      duration: 0
    })

    requestAnimationFrame(moveCursor);
  }

  function showCursor() {
    if (cursor.classList.contains('show')) {
      return false
    }

    cursor.classList.add('show');
    gsap.to(cursor, {
      opacity: 1,
      scale: 1,
      duration: 0.4
    })
  }

  function hideCursor() {
    cursor.classList.remove('show');
    gsap.to(cursor, {
      opacity: 0,
      scale: 0,
      duration: 0.4
    })
  }
  moveCursor();

  document.addEventListener("mousemove", function (event) {
    mouseX = event.clientX - (cursor.clientWidth / 2);
    mouseY = event.clientY - (cursor.clientHeight / 2);
  });

  hoverSection.forEach((section) => {
    section.addEventListener("mouseenter", showCursor);
    section.addEventListener("mouseleave", hideCursor);
  });


  const scrollThrottle = throttle(() => {
    hoverSection.forEach((element) => {
      const elementRect = {
        top: element.getBoundingClientRect().top,
        bottom: element.getBoundingClientRect().bottom
      }
      const cursorRect = {
        top: cursor.getBoundingClientRect().top,
        bottom: cursor.getBoundingClientRect().bottom
      }

      if (elementRect.top < cursorRect.top && elementRect.bottom > cursorRect.bottom) {
        showCursor();
      } else {
        hideCursor();
      }
    });
  }, 100)

  window.addEventListener("scroll", scrollThrottle);
}